<template>
    <div>
        <el-drawer
            :visible.sync="showModal"
            append-to-body
            direction="btt"
            @closed="resetForm"
            size="95%"
            :style="{
                maxWidth: '500px',
                left: '50%',
                transform: 'translateX(-50%)',
            }"
        >
            <template slot="title" class="mb-0">
                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                    <el-tag type="success">
                        <i class="el-icon-plus"></i>
                    </el-tag>
                    <h5 class="font-weight-semibold mb-0">Novo Banner</h5>
                </div>
            </template>

            <div class="px-4 pb-3 d-flex flex-grow-1 flex-column justify-content-between">
                <el-form
                    :model="payload" 
                    ref="bannerEditForm" 
                    label-position="top" 
                    status-icon
                > 
                    <el-row :gutter="12">
                        <!-- Descricao -->
                        <el-col>
                            <el-form-item
                                prop="descricao"
                                :rules="[
                                    { required: true, message: 'Nome é obrigatório' },
                                    { validator: validateMin(5, 'Nome deve possuir no mínimo 5 caracteres'), trigger: 'blur' },
                                ]"
                            >
                                <label>Descrição do banner</label>
                                <el-input
                                    v-model="payload.descricao" 
                                    placeholder="Digite a descrição"
                                    :disabled="isSubmiting"
                                    clearable
                                />
                            </el-form-item>
                        </el-col>   
  
                        <!-- App -->
                        <el-col>
                            <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                    <el-button type="primary" plain circle :style="{ pointerEvents: 'none' }">
                                        <i v-if="payload.app" class="el-icon-mobile"></i>
                                        <i v-else class="el-icon-monitor"></i>
                                    </el-button>
                                    <h6 class="mb-0 font-weight-bold">Exibir banner</h6>
                                </div>

                                <el-form-item prop="status" class="mb-0">
                                    <el-switch 
                                        v-model="payload.app"
                                        active-text="App"
                                        inactive-text="Desktop"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>

                        <!-- Upload -->
                        <el-col>
                            <el-form-item prop="imagem" :rules="[
                                { required: true, message: 'O banner é obrigatório' },
                            ]">
                                <label>Banner</label>
                                <FormDragAndDropUpload 
                                    v-model="payload.imagem"
                                    accept="image/*"
                                    :max-size="1"
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Vigencia Inicio -->
                        <el-col :span="12">
                            <el-form-item prop="fim_vigencia">
                                <label>Inicio da vigência</label>
                                <el-date-picker
                                    v-model="payload.inicio_vigencia"
                                    type="datetime"
                                    placeholder="Sem data de início"
                                    format="dd/MM/yyyy HH:mm"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    clearable
                                    size="small"
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Vigencia Fim -->
                        <el-col :span="12">
                            <el-form-item prop="fim_vigencia">
                                <label>Fim da vigência</label>
                                <el-date-picker
                                    v-model="payload.fim_vigencia"    
                                    type="datetime"
                                    placeholder="Sem data de término"
                                    format="dd/MM/yyyy HH:mm"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    clearable
                                    size="small"
                                />
                            </el-form-item>
                        </el-col>

                        <el-col>
                            <div class="d-flex p-2 border rounded align-items-center mb-2">
                                <small>Deixe em branco para não limitar o período</small>
                            </div>
                        </el-col>

                        <el-col>
                            <el-divider class="my-1"></el-divider>
                        </el-col>

                        <!-- Classes -->
                        <el-col>
                            <el-form-item prop="classe">
                                <label>Classes</label>
                                <el-select 
                                    v-model="payload.classe"
                                    placeholder="Selecione uma classe"
                                    clearable
                                    filterable
                                >
                                    <el-option 
                                        v-for="(classe, index) in classes"
                                        :key="classe.value"
                                        :label="classe.text"
                                        :value="classe.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <!-- Ativo -->
                         <el-col>
                            <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                    <el-button :type="payload.ativo ? 'success': 'danger'" plain circle :style="{ pointerEvents: 'none' }">
                                        <i v-if="payload.ativo" class="el-icon-unlock"></i>
                                        <i v-else class="el-icon-lock"></i>
                                    </el-button>
                                    <h6 class="mb-0 font-weight-bold">Banner {{ payload.ativo ? 'Ativo' : 'Inativo' }}</h6>
                                </div>

                                <el-form-item class="mb-0">
                                    <el-switch 
                                        v-model="payload.ativo"
                                        active-text="Ativo"
                                        inactive-text="Inativo"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>

                <!-- Actions -->
                <el-row class="mt-3">
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-button 
                                plain
                                type="danger"
                                :disabled="isSubmiting"
                                @click="() => {
                                    toggleModal();
                                    resetForm();
                                }"
                            >
                                Cancelar
                            </el-button>

                            <el-button 
                                type="primary"
                                :disabled="isSubmiting"
                                @click="onSubmit"
                            >
                                Salvar
                                <i v-if="isSubmiting" class="el-icon-loading"></i>
                                <i v-else class="el-icon-right"></i>
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-drawer>
    </div>
</template>
<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Input,
        Notification,
        Dialog,
        DatePicker,
        Tabs,
        TabPane,
        Drawer,
        Switch,
        Select,
        Option,
        Divider,
    } from "element-ui";

    import { FormDragAndDropUpload } from "@/components/_micro/Form/_index";

    // Utils
    import { validateMin, validateMax } from "@/schemas/generalSchema";

    // Api
    import { BannerApi } from "@/api/BannerApi";

    const bannerApi = new BannerApi();

    export default {
        data() {
            return {
                id: null,
                payload: {
                    descricao: null,
                    imagem: null,
                    app: false,
                    classe: null,
                    ordem: null,
                    ativo: null,
                    inicio_vigencia: null,
                    fim_vigencia: null,
                },
                showModal: false,
                isLoading: false,
                isSubmiting: false,
                classes: [
                    { text: 'A', value: 'A' },
                    { text: 'G', value: 'G' },
                    { text: 'V', value: 'V' },
                    { text: 'L', value: 'L' },
                    { text: 'P', value: 'P' },
                    { text: 'B', value: 'B' },
                    { text: 'D', value: 'D' },
                    { text: 'S', value: 'S' },
                ],
            }
        }, 
        methods: {
            onSubmit() {
                this.$refs.bannerEditForm.validate( async (valid) => {
                    if (!valid) {
                        this.$message({
                            message: 'Atenção, há campo(s) obrigatório(s) não preenchido(s)',
                            type: 'warning',
                            showClose: true,
                        });

                        return false
                    } 

                    const formData = new FormData();
                    formData.append('descricao', this.payload.descricao);
                    formData.append('imagem', this.payload.imagem);
                    formData.append('app', this.payload.app);
                    formData.append('classe', this.payload.classe);
                    formData.append('ordem', this.payload.ordem);
                    formData.append('ativo', this.payload.ativo);
                    formData.append('inicio_vigencia', this.payload?.inicio_vigencia ?? null);
                    formData.append('fim_vigencia', this.payload?.fim_vigencia ?? null);

                    this.isSubmiting = true;
                    
                    try {
                        await bannerApi.store(formData);

                        Notification.success({
                            title: 'Sucesso',
                            message: 'Banner criado com sucesso!'
                        });

                        this.toggleModal();
                        this.resetForm();
                        this.$emit('created');
                    } catch (error) {
                        if (error?.response?.status == 422) {
                            if (error?.response?.data.errors) {
                                Object.values(error.response.data.errors)
                                .flat()
                                .forEach(err_message => {
                                    Notification.warning({
                                        title: 'Atenção',
                                        message: err_message
                                    });
                                });
                            }
                            
                            return
                        }

                        Notification.error({
                            title: 'Erro',
                            message: error?.response?.message ?? 'Não foi possível criar o banner!'
                        });
                    } finally {
                        this.isSubmiting = false;
                    }
                })
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetForm() {
                if (this.$refs.bannerEditForm) {
                    this.$refs.bannerEditForm.resetFields();
                }
            },
            /**
             * Utils, Helpers
             */
            validateMin,
            validateMax,
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                    'gerente_regional'
                ]);
            },
        },
        components: {
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Button.name]: Button,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            [Dialog.name]: Dialog,
            [Drawer.name]: Drawer,
            [Switch.name]: Switch,
            [Select.name]: Select,
            [Option.name]: Option,
            [Divider.name]: Divider,
            [DatePicker.name]: DatePicker,
            FormDragAndDropUpload,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_macro/banner/BannerCreateModal.vue